import { useSeoMeta } from "@unhead/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AppShell } from "@/components/AppShell";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useSeoMeta({
    title: "404 — Polaroids",
    description: "This page doesn't exist.",
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <AppShell>
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div
          className="bg-polaroid-white rounded-[3px] p-4 pb-12 shadow-[0_3px_12px_rgba(45,27,78,0.1)] w-52 mx-auto"
          style={{ transform: 'rotate(-3deg)' }}
        >
          <div className="aspect-[4/5] flex items-center justify-center bg-cream-dark/50 rounded-sm">
            <span className="text-5xl">🔍</span>
          </div>
          <p className="font-hand text-pol-text text-center mt-2 text-xl">404</p>
        </div>
        <p className="text-pol-text-secondary text-sm mt-6">This page doesn't exist</p>
        <button
          onClick={() => navigate('/')}
          className="mt-4 text-sm text-pol-pink hover:text-pol-lilac transition-colors font-medium"
        >
          Back to feed →
        </button>
      </div>
    </AppShell>
  );
};

export default NotFound;
